"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionList = void 0;

var React = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ActionListItem = require("./ActionListItem");

var _NoResultsOverlay = _interopRequireDefault(require("../../../NoResultsOverlay"));

const Wrapper = _styledComponents.default.section`
  /* targeting the FilterList wrapper to remove padding */
  > div:first-of-type {
    padding: ${_blocks.spacing.loose} ${_blocks.spacing.loose} 0;
    margin-bottom: ${_blocks.spacing.snug};
    position: relative;
    height: 58px;
    &:after {
      content: '';
      display: block;
      position: absolute;
      right: 0;
      left: 0;
      height: 40px;
      bottom: 0;
      transform: translate(0, 100%);
      background: linear-gradient(${_blocks.palette.pureWhite} 25%, transparent);
      z-index: ${_blocks.layer.first};
    }
  }
`;
const ActionFilteredList = _styledComponents.default.ul`
  position: relative;
  height: 236px;
  overflow-y: auto;
  @media (min-height: 800px) {
    height: 435px;
  }
`;

const ActionList = ({
  actions,
  selectedAction,
  onSelect
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(_blocks.FilterList, {
    items: actions,
    filterKey: "valueString",
    placeholder: "Search Actions...",
    isTransparent: true
  }, ({
    visible
  }) => /*#__PURE__*/React.createElement(ActionFilteredList, null, visible.length === 0 ? /*#__PURE__*/React.createElement(_NoResultsOverlay.default, {
    noResultsMessage: true
  }) : visible.map(issue => /*#__PURE__*/React.createElement(_ActionListItem.ActionListItem, {
    key: issue.key,
    action: issue,
    isSelected: selectedAction !== undefined && selectedAction.key === issue.key,
    onSelect: onSelect
  })))));
};

exports.ActionList = ActionList;